import Helper from '@/utils/helper'
import Ticket from '@/app/service/api/model/ticket'

class Clients {
  constructor ({ clientsTitle, clients, clientsTitle2, clients2 }) {
    if (!Helper.isDefined(clients)) {
      throw new Error('Clients is undefined')
    }

    this.clients = clients.map((client) => new Ticket(client))
    this.clients2 = Helper.isDefined(clients2) ? clients2.map((client) => new Ticket(client)) : []
    this.clientsTitle = Helper.getValue(clientsTitle)
    this.clientsTitle2 = Helper.getValue(clientsTitle2)
  }

  hasClients () {
    return this.clients.length > 0
  }

  getClients () {
    return this.clients
  }

  getClientsTitle () {
    return this.clientsTitle
  }

  getClients2 () {
    return this.clients2
  }

  getClientsTitle2 () {
    return this.clientsTitle2
  }
}

export default Clients
